import React, { ReactNode } from "react";
import { MESFLogbookEntry } from "./entry";
import { MESFLogbookReport } from "./report";

export const logbookRoutesMESF: {
	path: string;
	element: ReactNode;
	permission?: string;
}[] = [
	{
		path: "/logbook/entry",
		element: React.createElement(MESFLogbookEntry),
	},
	{
		path: "/logbook/entry/:shiftId",
		element: React.createElement(MESFLogbookEntry),
	},
	{
		path: "/logbook/report",
		element: React.createElement(MESFLogbookReport),
	},
];

export const logbookNavbar = [
	{
		id: "logbook",
		label: "Logbook",
		items: [
			{
				label: "Logbook Entry",
				to: "/logbook/entry",
			},
			{
				label: "Logbook Report",
				to: "/logbook/report",
			},
		],
	},
];
